import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Get number of daily clicks from offer
 * @param {string} offer - slug of offer
 */
export async function getDailyOfferClicks(offer) {
  const BASE_URL = getMiddlewareUrl()

  try {
    const response = await fetch(
      `${BASE_URL}/api/clicks?cache_key=offer_${offer}_clicks`,
    )

    if (!response.ok) {
      throw new Error(`Fetch ${BASE_URL}/api/clicks failed!`)
    }

    const data = await response.json()

    return parseInt(data.click_count, 10) || 0
  } catch (error) {
    console.error(error)
  }
  return 0
}
